export const sankeyColors = [
  '#486DF0',
  '#F49352',
  '#D6475D',
  '#85357D',
  '#6F50E5',
  '#3C898E',
  '#F08696',
  '#F09EDA',
  '#9C86F0',
  '#90A5F0',
  '#75CBD1',
  '#F1C086',
];

export const sankeyColorsAlt = [
  '#B6C5F9',
  '#FBD4BA',
  '#EFB5BE',
  '#CEAECB',
  '#C5B9F5',
  '#B1D0D2',
  '#F9CFD5',
  '#F9D8F0',
  '#D7CFF9',
  '#D3DBF9',
  '#C8EAED',
  '#F9E6CF',
];
